import ENSChip from './ENSChip.container'
export default ENSChip
